import Image from "next/image"
import Link from "next/link"

import euCoFundedLt from "public/eu-co-funded-lt.png"
import euFunded from "public/eu.png"

import Facts from "./facts"

type Props = {
  /** When set, the EU emblem links to this path (used as the homepage banner). */
  emblemHref?: string
}

const EuProjects = ({ emblemHref }: Props) => {
  const emblem = (
    <Image
      src={euCoFundedLt}
      alt="Bendrai finansuoja Europos Sąjunga"
      sizes="(max-width: 640px) 90vw, 420px"
      className="h-auto w-full max-w-[420px]"
      priority
    />
  )

  return (
    <div className="mt-10 space-y-16">
      <section className="space-y-5">
        <div className="inline-block rounded-md border border-zinc-200 bg-white p-3 dark:border-zinc-700">
          {emblemHref ? (
            <Link
              href={emblemHref}
              className="block no-underline"
              aria-label="Apie ES bendrai finansuojamą projektą"
            >
              {emblem}
            </Link>
          ) : (
            emblem
          )}
        </div>
        <h2 className="pt-4 text-xl font-medium tracking-tight md:text-2xl">
          Išmanusis teisės asistentas, veikiantis pagal pažangius kalbos
          modelius
        </h2>
        <p>
          MB „Pirmas kodas“ pradėjo įgyvendinti projektą „Išmanusis teisės
          asistentas, veikiantis pagal pažangius kalbos modelius“.
        </p>
        <p>
          2022–2030 m. plėtros programos valdytoja LR Švietimo, mokslo ir sporto
          ministerija. Finansavimo šaltinis – ES fondų lėšos ir bendrojo
          finansavimo lėšos.
        </p>
        <Facts
          items={[
            { label: "Projekto biudžetas", value: "119 032.15 Eur" },
            {
              label: "Projekto veiklų vykdymo pradžia",
              value: "2026 m. rugsėjis",
            },
            {
              label: "Projekto veiklų vykdymo pabaiga",
              value: "2027 m. lapkritis",
            },
          ]}
        />
        <p>
          Projekto dėka, rinkai bus pateikiamas išmanusis teisės asistentas
          „Teise.ai“, veikiantis pagal pažangius kalbos modelius. Vartotojas
          turės galimybę patirti natūralų bendravimą lietuvių kalba ir gauti
          pagalbą įvairiems teisės klausimams spręsti. Produktas yra inovatyvus,
          nes tai kol kas vienintelis dirbtinio intelekto įrankis Lietuvoje,
          skirtas suteikti konsultacijas, susijusias su įvairiais teisės
          klausimais.
        </p>
        <p className="font-medium">
          Projektas bendrai finansuojamas Europos Sąjungos lėšomis
        </p>
      </section>

      <section className="space-y-5 border-t border-zinc-200 pt-16 dark:border-zinc-800">
        <Image
          src={euFunded}
          alt="Co-funded by the European Union"
          className="h-auto w-64 invert dark:invert-0"
        />
        <h2 className="pt-4 text-xl font-medium tracking-tight md:text-2xl">
          Unified document and communication language model and an intelligent
          medical language model for healthcare documents development
        </h2>
        <p>
          UAB Taikomasis dirbtinis intelektas has launched the project
          „Development of a unified document and communication language model
          and an intelligent medical language model for healthcare documents“ No
          02-020-K-0013. The project is funded by the European Regional
          Development Fund.
        </p>
        <Facts
          items={[
            { label: "Project partner", value: "MB Pirmas kodas" },
            {
              label: "Project budget",
              value: "€ 1 486 827, financing by EU funds up to € 1 107 546",
            },
            { label: "Duration", value: "June 10, 2024 – June 10, 2026" },
          ]}
        />
        <p>
          The project aims to develop a unified language model for documentation
          and communication and an intelligent medical language model for
          healthcare documents. The developed smart language model will focus on
          identifying potential business gaps and suggesting improvements. In
          addition, the system will predict the company&apos;s financial
          performance based on the content of the analysed documentation.
        </p>
        <p>
          The uniqueness of this model lies in its ability to retrospectively
          analyse past projects and generate adapted plans for future
          situations. This will enable the company to allocate human and
          financial resources more efficiently. The model will be integrated
          with the company&apos;s existing systems and adapted to comply with
          sector-specific regulations and rules, ensuring ethically and legally
          sustainable solutions.
        </p>
        <p>
          The project will contribute to the development of new high value-added
          products, allowing researchers to participate in the company&apos;s
          research and experimental development activities, promoting early
          pilot production of the new product developed and market readiness
          activities.
        </p>
      </section>
    </div>
  )
}

export default EuProjects
